import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: "Unauthorized failed" };
  }
);

async function GetApiToken() {
  try {
    const response = await client.get('Carep/GetApiToken');
    return response.data;
  } catch (error) {
    throw  'An error occurred.';
  }
}

async function SendReferral(data, jwtToken) {
  try {
    const response = await client.post('Carep/SendReferral', data, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`, 
           'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw  'An error occurred.';
  }
}

async function UploadReferralFiles(files, referralId, jwtToken) {
  try {
    const payload = {
      files: files.map(file => ({
        fileName: file.fileName,
        sourceType: String(file.sourceType),
        url: file.url
      })),
      referralId: referralId
    };
    
    const response = await client.post('Carep/UploadReferralFiles', payload, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`, 
           'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw 'An error occurred.';
  }
}

async function PublishReferral(referralId, jwtToken) {
  try {
    const response = await client.put(
      'Carep/PublishReferral',
      { referralId },
      {
        headers: {
          "Carep-Authorization": `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('An error occurred.');
  }
}

async function GetContracts(jwtToken) {
  if (!jwtToken) {
    throw new Error("JWT Token is required.");
  }

  try {
    const response = await client.get("Carep/GetContracts", {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw new Error('An error occurred in GetContracts.');
  }
}


async function GetOffer(rid, jwtToken) {
  try {
    const response = await client.get(`Carep/GetOffer?rid=${rid}`, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw 'An error occurred in GetOffer.';
  }
}

async function GetFinalActDetails(id, jwtToken) {
  try {
    const response = await client.get(`Carep/GetFinalActDetails?id=${id}`, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw  'An error occurred in GetFinalActDetails.';
  }
}

async function GetUploadedFiles(policynumber, sourcetype = 0, jwtToken) {
  try {
    const response = await client.get(`Carep/GetUploadedFiles?policynumber=${policynumber}&sourcetype=${sourcetype}`, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw  'An error occurred in GetUploadedFiles.';
  }
}

async function UpdateOfferStatus(payload, jwtToken) {
  try {
    const response = await client.put(
      'Carep/UpdateOfferStatus',
      payload,
      {
        headers: {
          "Carep-Authorization": `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error( 'An error occurred while updating the offer status.');
  }
}

async function ConfirmReferral(payload, jwtToken) {
  try {
    const response = await client.put(
      'Carep/ConfirmReferral',
      payload,
      {
        headers: {
          "Carep-Authorization": `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('An error occurred while confirming the referral.');
  }
}

async function RejectReferral(payload, jwtToken) {
  try {
    const response = await client.put(
      'Carep/RejectReferral',
      payload,
      {
        headers: {
          "Carep-Authorization": `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error( 'An error occurred while rejecting the referral.');
  }
}

async function GetCarepReferral(id, jwtToken) {
  try {
    const response = await client.get(`Carep/GetReferral?id=${id}`, {
      headers: {
        "Carep-Authorization": `Bearer ${jwtToken}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw 'An error occurred in GetOffer.';
  }
}

async function CheckToken(jwtToken) {
  try {
    const response = await client.post(
      'Carep/CheckToken',
      { jwtToken }, 
      {
        headers: {
          "Carep-Authorization": `Bearer ${jwtToken}`, 
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data; 
  } catch (error) {
    throw 'An error occurred in CheckToken.';
  }
}

function CreateReferral(item) {
  return client.post("CarepClaim", item);
}

function GetClaimReferral(id) {
  return client.get(`CarepClaim/GetClaimReferral/${id}`);
}

function GetClaimReferralsById(claimId,referralId) {
  return client.get(`CarepClaim/GetClaimReferralsById/${claimId}/${referralId}`);
}

function GetClaimReferrals() {
  return client.get("CarepClaim/GetClaimReferrals/");
}


export {
  GetApiToken,
  SendReferral,
  UploadReferralFiles,
  PublishReferral,
  GetContracts,
  GetOffer,
  UpdateOfferStatus,
  GetFinalActDetails,
  ConfirmReferral,
  RejectReferral,
  CreateReferral,
  GetClaimReferral,
  GetClaimReferrals,
  GetClaimReferralsById,
  GetUploadedFiles,
  GetCarepReferral,
  CheckToken,
};
